export default __webpack_public_path__ + "static/media/boxshot.347f4ee3.png";